module.exports = __webpack_public_path__ + "img/SH2D_30005.5d5843ab.png";